import React from "react";
import {
  CloseIcon,
  Body,
  Box,
  Heading,
} from "@edreamsodigeo/prisma-design-system";
import { useBrand, useTranslation } from "@edreamsodigeo/frontend-core";

import styles from "./styles";
import PrimeLogo from "~/public/PrimeLogo";
import { BrandBackground } from "~/components/common/BrandBackground";

export interface LightBoxHeaderDesktopProps {
  onClose: () => void;
  freeTrialDays?: number;
}

const LightboxHeaderDesktop: React.FC<LightBoxHeaderDesktopProps> = ({
  onClose,
  freeTrialDays,
}) => {
  const { t } = useTranslation();
  const brand = useBrand();

  const subtitleText =
    freeTrialDays &&
    t("visibility.lightbox.desktop.subtitle", {
      freeTrialDays,
    });

  const themeStyles = styles[brand];

  return (
    <div style={themeStyles.container}>
      <BrandBackground>
        <div style={themeStyles.closeIconContainer}>
          <div
            style={themeStyles.closeIconWrapper}
            onClick={onClose}
            data-testid={"closeIconHeader"}
          >
            <CloseIcon
              color={"neutral.0"}
              hoverColor={"neutral.60"}
              size={"medium"}
            />
          </div>
        </div>
        <div style={themeStyles.contentContainer}>
          <PrimeLogo type={"long"} size={"s"} negative />
          <Box mt={"base"}>
            <Body
              type={"xxSmall"}
              color={"neutral.0"}
              weight={"medium"}
              style={themeStyles.member}
            >
              {t("visibility.lightbox.members")}
            </Body>
          </Box>
          <Box mt={"1x_small"}>
            <Heading
              type={"3"}
              weight={"medium"}
              color={"neutral.0"}
              style={themeStyles.title}
            >
              {t("visibility.lightbox.title")}
            </Heading>
          </Box>
          <Box mt={"1x_small"}>
            <Body
              type={"xSmall"}
              weight={"normal"}
              style={themeStyles.subtitle}
            >
              {subtitleText}
            </Body>
          </Box>
        </div>
      </BrandBackground>
    </div>
  );
};

export default LightboxHeaderDesktop;
